<template>
  <div class="bulletins-page">
    <div class="bulletins-page__container">
      <div class="bulletins-header">
        <span class="bulletins-title">
          ACTIVE BULLETINS
        </span>
        <span class="bulletins-title-warning" v-if="isWarningMessageVisible">
          {{ this.warningMessage }}
        </span>
      </div>
      <div class="bulletins-content">
        <nb-table
          id="activeBulletinsList"
          :data="activeBulletinsList"
          :border="true"
          :stripe="true"
          :responsive="true"
          :default-sort="{}"
        >
          <nb-table-column
            prop="c_navblueReference"
            width="100"
            label="NAVBLUE Reference"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_notificationPublishedDate"
            width="100"
            label="Published Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_expirationDate"
            width="100"
            label="Expiry Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="bulletinType"
            width="100"
            label="Bulletin Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_continentRegion"
            width="100"
            label="Region"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_countryId"
            width="120"
            label="Country"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_region"
            width="100"
            label="Data Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_subject"
            width="250"
            label="Bulletin Subject"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_productAffected"
            width="100"
            label="Product"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_databaseType"
            width="150"
            label="Database Type"
            sortable
          ></nb-table-column>
          <nb-table-column label="Acknowledge Name" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.signed">
                {{ scope.row.signedName }}
              </div>
            </template>
          </nb-table-column>
          <nb-table-column label="Acknowledge Date" width="140">
            <template slot-scope="scope">
              <div v-if="scope.row.signed">
                {{ scope.row.signedDate }}
              </div>
            </template>
          </nb-table-column>
          <nb-table-column label="Bulletin PDF" width="200" align="center">
            <template slot-scope="scope">
              <nb-button
                :loading="scope.row.loadingStatus"
                @click="downloadPdf(activeBulletinsList, scope.row)"
                type="text"
              >
                DOWNLOAD
              </nb-button>
              <div v-if="scope.row.loadingStatus == true">
                <nb-progress />
              </div>
              <nb-button
                :loading="scope.row.loadingStatus"
                @click="viewPdf(activeBulletinsList, scope.row)"
                type="text"
                target="_blank"
              >
                VIEW
              </nb-button>
              <div v-if="scope.row.loadingStatus == true">
                <nb-progress />
              </div>
            </template>
          </nb-table-column>
          <nb-table-column label="Signed" width="120">
            <template slot-scope="scope">
              <nb-checkbox
                v-model="scope.row.signed"
                @change="handleSignedBulletinChange($event, scope.row)"
              />
            </template>
          </nb-table-column>
        </nb-table>
      </div>
      <div class="bulletins-header">
        <span class="bulletins-title">
          EXPIRED BULLETINS
        </span>
      </div>
      <div class="bulletins-content">
        <nb-table
          id="expiredBulletinsList"
          :data="expiredBulletinsList"
          :border="true"
          :stripe="true"
          :responsive="true"
          :default-sort="{}"
        >
          <nb-table-column
            prop="c_navblueReference"
            width="100"
            label="NAVBLUE Reference"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_notificationPublishedDate"
            width="100"
            label="Published Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_expirationDate"
            width="100"
            label="Expiry Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="bulletinType"
            width="100"
            label="Bulletin Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_continentRegion"
            width="100"
            label="Region"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_countryId"
            width="120"
            label="Country"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_region"
            width="100"
            label="Data Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_subject"
            width="340"
            label="Bulletin Subject"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_productAffected"
            width="100"
            label="Product"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_databaseType"
            width="150"
            label="Database Type"
            sortable
          ></nb-table-column>
          <nb-table-column label="Bulletin PDF" width="180" align="center">
            <template slot-scope="scope">
              <nb-button
                @click="downloadPdf(expiredBulletinsList, scope.row)"
                type="text"
                :loading="scope.row.loadingStatus"
              >
                DOWNLOAD
              </nb-button>
              <div v-if="scope.row.loadingStatus == true">
                <nb-progress />
              </div>
              <nb-button
                :loading="scope.row.loadingStatus"
                @click="viewPdf(expiredBulletinsList, scope.row)"
                type="text"
                target="_blank"
              >
                VIEW
              </nb-button>
              <div v-if="scope.row.loadingStatus == true">
                <nb-progress />
              </div>
            </template>
          </nb-table-column>
        </nb-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as API from "../API/APIFunctions.js";

export default {
  data() {
    return {
      activeBulletinsList: [],
      expiredBulletinsList: [],
      signedBulletinsList: [],
      isWarningMessageVisible: false,
      warningMessage:
        "Warning: No Active bulletin available as no region is selected in the settings."
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentCustomer",
      "getCompiledUsername",
      "getCurrentUser"
    ])
  },
  methods: {
    downloadPdf(data, row) {
      const rowIndex = data.indexOf(row);
      data[rowIndex].loadingStatus = true;
      API.downloadPdf(row.id, row.c_selectType).then(() => {
        data[rowIndex].loadingStatus = false;
      });
    },
    viewPdf(data, row) {
      const rowIndex = data.indexOf(row);
      data[rowIndex].loadingStatus = true;
      API.viewPdf(row.id, row.c_selectType).then(() => {
        data[rowIndex].loadingStatus = false;
      });
    },
    prepareSignedPayload(rowData) {
      let acknowledgeDate = this.currentDate();
      const payload = [
        { id: "bulletinId", value: rowData.id },
        { id: "contactId", value: this.getCompiledUsername },
        { id: "acknowledgementDate", value: acknowledgeDate },
        { id: "customerId", value: this.getCurrentCustomer.name }
      ];
      return payload;
    },
    // update signed bulletin locally
    updateSignedData(isChecked, rowIndex, signedId) {
      let acknowledgeDate = this.currentDate();
      this.activeBulletinsList[rowIndex].signedDate = isChecked
        ? acknowledgeDate
        : "";
      this.activeBulletinsList[rowIndex].signedName = isChecked
        ? this.getCompiledUsername
        : "";
      this.activeBulletinsList[rowIndex].signedId = isChecked ? signedId : "";
    },
    currentDate() {
      const current = new Date();
      let day = `${current.getDate()}`;
      let month = `${current.getMonth() + 1}`;

      if (day < 10) {
        day = "0" + day;
      }

      if (month < 10) {
        month = `0${month}`;
      }
      const date = `${current.getFullYear()}-${month}-${day}`;
      return date;
    },
    // update joget db with signed bulletins info
    // and write joget id in local store
    handleSignedBulletinChange(isChecked, rowData) {
      const rowIndex = this.activeBulletinsList.indexOf(rowData);
      if (isChecked) {
        const payload = this.prepareSignedPayload(rowData);
        API.storeData(
          process.env.VUE_APP_BULLETIN_APP_ID,
          "" + process.env.VUE_APP_BULLETIN_FORM_SIGNED,
          "",
          payload
        )
          .then(response => response.json())
          .then(data => {
            this.updateSignedData(isChecked, rowIndex, data.id);
            console.log("Data store success");
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        const signedId = this.activeBulletinsList[rowIndex].signedId;
        API.deleteData(
          process.env.VUE_APP_BULLETIN_APP_ID,
          "" + process.env.VUE_APP_BULLETIN_FORM_SIGNED,
          signedId
        )
          .then(response => response.json())
          .then(() => {
            this.updateSignedData(isChecked, rowIndex, signedId);
            console.log("Delete success");
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    fetchSignedBulletinsList(jogetSignedList) {
      return new Promise((resolve, reject) => {
        API.fetchList(process.env.VUE_APP_BULLETIN_APP_ID, "" + jogetSignedList)
          .then(response => {
            const { data } = response;
            data.forEach(item => {
              if (this.getCurrentCustomer.name === item.customerId) {
                this.signedBulletinsList.push(item);
              }
            });
            resolve();
          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
      });
    },
    // Fill bulletinsList with the bulletins of the list jogetList of joget backend
    // according to the regions the customer of the current user suscribed to.
    fetchBulletinList(jogetList, bulletinsList) {
      const customerRegionsList = this.getCurrentCustomer.regions;
      if (customerRegionsList == "") {
        this.isWarningMessageVisible = true;
        return;
      }
      return new Promise((resolve, reject) => {
        API.fetchList(process.env.VUE_APP_BULLETIN_APP_ID, "" + jogetList)
          .then(response => {
            const { data } = response;
            this.pushResultList(data, bulletinsList, customerRegionsList);
            resolve();
          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
      });
    },
    // Fill bulletinsList with the bulletins of the list jogetList of joget backend
    // according to the regions the customer of the current user suscribed to.
    fetchBulletinListWithFilter(jogetList, bulletinsList, filters) {
      const customerRegionsList = this.getCurrentCustomer.regions;
      if (customerRegionsList == "") {
        this.isWarningMessageVisible = true;
        return;
      }
      return new Promise((resolve, reject) => {
        API.fetchList(
          process.env.VUE_APP_BULLETIN_APP_ID,
          "" + jogetList,
          filters
        )
          .then(response => {
            const { data } = response;
            this.pushResultList(data, bulletinsList, customerRegionsList);
            resolve();
          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
      });
    },
    pushResultList(data, bulletinsList, customerRegionsList) {
      console.log("Inside pushResultList");
      data.forEach(element => {
        element.loadingStatus = false;

        // add signed bulletin data to main bulletinsList data
        const signedBulletin = this.signedBulletinsList.find(
          el => el.bulletinId === element.id
        );
        element.signed = signedBulletin ? true : false;
        element.signedDate = signedBulletin
          ? signedBulletin.acknowledgementDate
          : "";
        element.signedName = signedBulletin ? signedBulletin.contactId : "";
        element.signedId = signedBulletin ? signedBulletin.id : "";

        // populate bulletinsList with data from joget,
        // filtered by region, except if bulletin is an ommited one
        const bulletinRegion = element.c_continentRegion;
        if (customerRegionsList.includes(bulletinRegion)) {
          bulletinsList.push(element);
        } else if (
          element.c_selectType ===
          process.env.VUE_APP_JOGET_BMT_OMMITED_TYPE_VALUE
        ) {
          bulletinsList.push(element);
        }
      });
      console.log("End pushResultList");
    }
  },
  created() {
    this.fetchSignedBulletinsList(
      process.env.VUE_APP_BULLETIN_SIGNED_LIST
    ).then(() => {
      this.fetchBulletinListWithFilter(
        process.env.VUE_APP_ACTIVE_BULLETINS_LIST,
        this.activeBulletinsList,
        process.env.VUE_APP_JOGET_BMT_FILTER_ACTIVE_FOR_CONTACT_EMAIL +
          "=" +
          this.getCurrentUser.username
      );
      if (process.env.VUE_APP_BULLETIN_LISTS_OLD_FETCH_STATUS === "Y") {
        this.fetchBulletinList(
          process.env.VUE_APP_ACTIVE_BULLETINS_LIST_OLD,
          this.activeBulletinsList
        );
      }
    });

    this.fetchBulletinListWithFilter(
      process.env.VUE_APP_EXPIRED_BULLETINS_LIST,
      this.expiredBulletinsList,
      process.env.VUE_APP_JOGET_BMT_FILTER_EXPIRED_FOR_CONTACT_EMAIL +
        "=" +
        this.getCurrentUser.username
    );
    if (process.env.VUE_APP_BULLETIN_LISTS_OLD_FETCH_STATUS === "Y") {
      this.fetchBulletinList(
        process.env.VUE_APP_EXPIRED_BULLETINS_LIST_OLD,
        this.expiredBulletinsList
      );
    }
  }
};
</script>

<style lang="scss">
.bulletins-page {
  //display: flex;
  justify-content: center;
  //min-height: calc(100vh - var(--size-bar));
  //max-height: calc(100vh - var(--size-bar) + 12px);
  background-image: linear-gradient(#fe30540f, #1624570f);
  .bulletins-page__container {
    min-width: calc(var(--unit) * 65);
    box-shadow: 0 8px 20px 0 rgba(25, 25, 25, 0.2);
    overflow: scroll;
    .bulletins-header {
      background-color: white;
      height: calc(var(--unit) * 4);
      display: flex;
      align-items: center;
      .bulletins-title {
        font-size: calc(var(--unit) * 1.5);
        font-weight: 700;
        color: #333;
        margin-left: calc(var(--unit) * 2);
        .nb-icon {
          margin-right: var(--unit);
        }
      }
      .bulletins-title-warning {
        font-style: italic;
        font-size: calc(var(--unit) * 1.5);
        color: #333;
        margin-left: calc(var(--unit) * 2);
      }
    }
  }
}
.bulletins-content {
  background-color: #ebebeb;
  padding: calc(var(--unit) * 2);
  .bulletins_title {
    margin-bottom: calc(var(--unit) * 2);
    font-size: var(--unit);
    color: var(--color-black4);
    display: flex;
    align-items: center;
    .nb-icon {
      margin-right: calc(var(--unit) * 0.75);
    }
  }
}
</style>
